type AudioContextWithWebKit = typeof globalThis & {
  webkitAudioContext?: typeof AudioContext;
};

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (audioContext) return audioContext;
  const audioGlobal = globalThis as AudioContextWithWebKit;
  const AudioContextConstructor = audioGlobal.AudioContext ?? audioGlobal.webkitAudioContext;
  if (!AudioContextConstructor) return null;
  try {
    audioContext = new AudioContextConstructor();
    return audioContext;
  } catch {
    return null;
  }
}

function scheduleCoinTone(
  context: AudioContext,
  startAt: number,
  frequency: number,
  duration: number,
  volume: number,
  type: OscillatorType,
  endFrequency = frequency,
): void {
  const oscillator = context.createOscillator();
  const envelope = context.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startAt);
  oscillator.frequency.exponentialRampToValueAtTime(endFrequency, startAt + duration);
  envelope.gain.setValueAtTime(0.0001, startAt);
  envelope.gain.exponentialRampToValueAtTime(volume, startAt + 0.006);
  envelope.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  oscillator.connect(envelope);
  envelope.connect(context.destination);
  oscillator.onended = () => {
    oscillator.disconnect();
    envelope.disconnect();
  };
  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.02);
}

function playCashChime(context: AudioContext, delayMs: number): void {
  const startAt = context.currentTime + 0.01 + delayMs / 1_000;
  scheduleCoinTone(context, startAt, 180, 0.08, 0.045, "square", 110);
  scheduleCoinTone(context, startAt + 0.025, 1_318, 0.1, 0.1, "triangle", 1_110);
  scheduleCoinTone(context, startAt + 0.065, 1_975, 0.09, 0.07, "sine", 1_660);
  scheduleCoinTone(context, startAt + 0.12, 1_568, 0.1, 0.085, "triangle", 1_320);
  scheduleCoinTone(context, startAt + 0.18, 1_046.5, 0.55, 0.11, "sine");
  scheduleCoinTone(context, startAt + 0.18, 2_093, 0.38, 0.045, "sine");
}

export function primeSanctionEffects(): void {
  const context = getAudioContext();
  if (context?.state === "suspended") {
    void context.resume().catch(() => undefined);
  }
}

export function playSanctionEffects(delayMs = 0): void {
  const vibrate = () => {
    try {
      navigator.vibrate?.([60, 35, 90, 35, 140]);
    } catch {
      // Vibration is optional and unavailable on some mobile browsers.
    }
  };
  if (delayMs > 0) window.setTimeout(vibrate, delayMs);
  else vibrate();

  const context = getAudioContext();
  if (!context) return;
  if (context.state === "suspended") {
    void context.resume().then(() => playCashChime(context, delayMs)).catch(() => undefined);
    return;
  }
  playCashChime(context, delayMs);
}
